import React from 'react'

import withCategory from '../hoc/with-category'
import declOfNum from '../../utils/declOfNum'

const CatalogueContentTitle = ({categoryTitle, setCurrentCategory, goods}) => {
  setCurrentCategory(categoryTitle);

  return (
    <div className="product-catalogue__section-title">
      <h2 className="product-catalogue__section-name"> {categoryTitle} </h2>
      <span className="amount"> {goods} {declOfNum(goods, ['товар', 'товара', 'товаров'])}</span>
    </div>
  )
};

export default withCategory(CatalogueContentTitle)
